import React from 'react'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import Table from '@mui/material/Table'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import { SelectUnit } from '../types'
import { styled } from '@mui/material/styles'

interface Props {
  title: string
  items: SelectUnit[]
  onChange: (e: React.ChangeEvent<{ value: unknown }>, item: SelectUnit) => void
  width: number
}

const CardHeaderComponent = styled(CardHeader)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[500]}`,
}))
export const UnitsCardComponent: React.FC<Props> = ({
  title,
  items,
  onChange,
  width,
}) => {
  const minMaxHeight = width >= 1200 ? 200 : undefined
  return (
    <Card raised>
      <CardHeaderComponent title={title} />
      <CardContent sx={{ minHeight: minMaxHeight, maxHeight: minMaxHeight }}>
        <Table size="small">
          <thead>
            <tr>
              <th align="left">Size</th>
              <th align="left">Price</th>
              <th align="left">Qty</th>
            </tr>
          </thead>
          <tbody>
            {items.map((x) => {
              const _options: Array<{ value: string; label: string }> = []
              const _length = Number(x.quantity) - Number(x.occupied)
              for (let i = 0; i < _length; i++) {
                const _value = (i + 1).toString()
                _options.push({ value: _value, label: _value })
              }
              _options.unshift({ value: '0', label: '-Select-' })
              return (
                <tr key={x.id}>
                  <td>{x.size}</td>
                  <td>{x.price}</td>
                  <td>
                    <FormControl fullWidth size="small">
                      <Select
                        value={x.value}
                        onChange={(e) =>
                          onChange(
                            e as React.ChangeEvent<{ value: unknown }>,
                            x
                          )
                        }
                      >
                        {_options.map((x) => (
                          <MenuItem key={x.value} value={x.value}>
                            {x.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      </CardContent>
    </Card>
  )
}
